<template>
    <button
        :class="['element-button', `element-button--${theme}`]"
        :type="type">
        <slot></slot>
        <span v-if="label"
            class="btn__label">
            {{ label }}
        </span>
    </button>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: ''
        },
        theme: {
            type: String,
            default: 'outline-secondary'
        },
        type: {
            type: String,
            default: 'button'
        },
        href: {
            type: String,
            default: null
        }
    },
    computed: {
        buttonLabel () {
            return this.label
        }
    }
}
</script>
